import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';

export class DevicePropertyEntity implements Entity {
  public static fromXML(xml) {
    const attrs = xml._attributes;
    return {
      entity: new DevicePropertyEntity(
        parseInt(attrs[ATTRS.DeviceProperty.DevicePropertyObjectId], 10),
        attrs[ATTRS.DeviceProperty.DevicePropertyDDI],
        parseInt(attrs[ATTRS.DeviceProperty.DevicePropertyValue], 10),
        attrs[ATTRS.DeviceProperty.DevicePropertyDesignator],
        attrs[ATTRS.DeviceProperty.DevicePropertyObjectId]
          ? parseInt(attrs[ATTRS.DeviceProperty.DevicePropertyObjectId], 10)
          : null
      ),
    };
  }
  public type = TAGS.DeviceProperty;

  constructor(
    public objectId: number,
    public DDI: string,
    public value: number,
    public designator?: string,
    public deviceValuePresentationObjectId?: number
  ) {}

  public toXML() {
    return {
      _attributes: {
        [ATTRS.DeviceProperty.DevicePropertyObjectId]: this.objectId,
        [ATTRS.DeviceProperty.DevicePropertyDDI]: this.DDI,
        [ATTRS.DeviceProperty.DevicePropertyValue]: this.value,
        [ATTRS.DeviceProperty.DevicePropertyDesignator]: this.designator,
        [ATTRS.DeviceProperty.DeviceValuePresentationObjectId]:
          this.deviceValuePresentationObjectId,
      },
    };
  }
}
